import React from "react";
import PasswordInput from "apollo-react/components/PasswordInput";
import Info from 'apollo-react-icons/Info';

const PasswordField = ({
	field,
	meta,
	label,
	onChange,
	value,
	required,
	placeholder,
	fullWidth = true,
}) => {
	return (
		<PasswordInput
			{...field}
			// label={label}
			label={<span style={{display:'flex',alignItems:"flex-start", gap:4, lineHeight:"21px"}}>{label} { <Info fontSize="extraSmall" style={{color:"#595959"}} />}</span>}
			
			placeholder={placeholder}
			error={meta.touched && !!meta.error}
			helperText={meta.touched && meta.error ? meta.error : ""}
			onChange={(e) => onChange(e.target.value)}
			fullWidth={fullWidth}
			required={required}
			value={value}
		/>
	);
};

export default PasswordField;
